import React from 'react';
import { motion } from 'framer-motion';
import {
  Eye,
  Target,
  ShieldCheck,
  Sparkles,
  Leaf,
  Star,
  Users,
} from 'lucide-react';

const fadeInUp = {
  hidden: { opacity: 0, y: 40 },
  visible: { opacity: 1, y: 0 },
};

const About = () => {
  return (
    <motion.section
      id="about"
      className="py-20 max-w-7xl mx-auto px-4"
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, amount: 0.3 }}
      transition={{ duration: 0.8 }}
      variants={fadeInUp}
    >
      <h2 className="text-4xl font-bold text-royalBlue text-center mb-16">About Us</h2>

      <div className="grid md:grid-cols-2 gap-12 items-center">
        {/* Left image */}
        <div className="rounded-xl overflow-hidden shadow-lg">
          <img
            src="/images/about-khalanga.avif" // Replace with your image path
            alt="Khalanga Global Ventures"
            className="w-full h-auto object-cover"
          />
        </div>

        {/* Right content */}
        <div>
          <div className="mb-8">
            <h3 className="text-2xl font-semibold mb-4 text-black">Company Overview</h3>
            <p className="text-gray-700 mb-4">
              Khalanga Global Ventures (Pty) Ltd is a multi-disciplinary African enterprise
              committed to excellence in Freight & Logistics, Infrastructure & Civil Engineering,
              and Construction Services. Headquartered in Johannesburg, we serve both private and public
              sectors across the continent with integrated solutions designed to move economies forward.
            </p>
            <p className="text-gray-700">
              Our diverse service offerings and strategic partnerships enable us to provide turnkey solutions
              that meet the demands of a rapidly evolving industrial and infrastructural landscape.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {/* Vision */}
            <div className="flex items-start space-x-4">
              <Eye className="text-royalBlue w-6 h-6 mt-1" />
              <div>
                <h4 className="font-semibold">Vision</h4>
                <p className="text-gray-600">
                  To become Africa’s most trusted and innovative partner in logistics and infrastructure development by 2030.
                </p>
              </div>
            </div>

            {/* Mission */}
            <div className="flex items-start space-x-4">
              <Target className="text-royalBlue w-6 h-6 mt-1" />
              <div>
                <h4 className="font-semibold">Mission</h4>
                <p className="text-gray-600">
                  To deliver world-class infrastructure and logistics solutions through innovation, sustainability, and excellence—empowering communities and enabling economic growth.
                </p>
              </div>
            </div>
          </div>

          {/* Core Values */}
          <div className="mt-10">
            <h3 className="text-2xl font-semibold mb-4 text-black">Core Values</h3>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 text-gray-700">
              <div className="flex items-start space-x-3">
                <ShieldCheck className="text-royalBlue w-5 h-5 mt-1" />
                <p><strong>Integrity:</strong> We do the right thing, always.</p>
              </div>
              <div className="flex items-start space-x-3">
                <Sparkles className="text-royalBlue w-5 h-5 mt-1" />
                <p><strong>Innovation:</strong> We embrace creativity and technology to improve efficiency.</p>
              </div>
              <div className="flex items-start space-x-3">
                <Leaf className="text-royalBlue w-5 h-5 mt-1" />
                <p><strong>Sustainability:</strong> We build and move with the future in mind.</p>
              </div>
              <div className="flex items-start space-x-3">
                <Star className="text-royalBlue w-5 h-5 mt-1" />
                <p><strong>Excellence:</strong> We deliver quality beyond expectations.</p>
              </div>
              <div className="flex items-start space-x-3">
                <Users className="text-royalBlue w-5 h-5 mt-1" />
                <p><strong>Collaboration:</strong> We grow through partnerships and teamwork.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </motion.section>
  );
};

export default About;
